(() => {
  'use strict';

  function normalizeHref(anchor) {
    const href = anchor.getAttribute('href') || '';
    if (!href || href === '#') return;

    if (href === '#ticho-shop-by-room') {
      anchor.addEventListener('click', (event) => {
        const target = document.getElementById('ticho-shop-by-room');
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        history.replaceState(null, '', '#ticho-shop-by-room');
      });
    }
  }

  function init() {
    document.querySelectorAll('body.template-index a[href]').forEach(normalizeHref);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
